import { create } from "zustand";
import { SilabusUploadProccess } from "../const/types";

type State = {
  silabusUploadProccesses: SilabusUploadProccess[];
  status: null | "tambah" | "update";
};

type Action = {
  setStatus: (newStatus: State["status"]) => void;
  setSilabusUploadProccesses: (newUploadProccess: any) => void;
  removeSilabusUploadProccess: (idToRemove: Date) => void;
};

const useSilabusUploadProccesses = create<State & Action>((set) => ({
  status: null,
  silabusUploadProccesses: [],

  setStatus: (newStatus) => set(() => ({ status: newStatus })),

  setSilabusUploadProccesses: (newUploadProccess) =>
    set(() => ({ silabusUploadProccesses: newUploadProccess })),

  removeSilabusUploadProccess: (idToRemove) =>
    set((state) => ({
      silabusUploadProccesses: state.silabusUploadProccesses.filter(
        (uploadProcess) => uploadProcess.id !== idToRemove
      ),
    })),
}));

export default useSilabusUploadProccesses;
